import {segment} from './helpers'

export const reviewImageModalOpened = (payload) => segment('Opened Review Image', payload)

export const reviewPageFiltered = (payload) => segment('Filtered Review Page', payload)
